import store from '@/store/store';
import apiOrgs from '@/api/orgs';
import apiUsages from '@/api/usages';
import utils from '@/utils';
import { USAGE_LABEL } from '@/constants';

const tracking = {
    getOrganizationStatus(organizationId, idToken) {
        return apiOrgs.statuses
            .get(idToken, organizationId)
            .then(response => {
                return response.data.startDate;
            })
            .catch(error => {});
    },

    async setUsages(idToken) {
        const storedUsage = JSON.parse(localStorage.getItem('usage'));
        const today = utils.formatDate(new Date(), 'YYYY-MM-DD');
        // 取得するキーを指定
        const keys = Object.keys(USAGE_LABEL);
        // ローカルストレージに値がない場合のみAPIから値を取得して設定
        if (!storedUsage || storedUsage.date != today) {
            const res = await this.getUsagesApi(idToken, keys);
            const data = this.formatUsageData(res);
            if (data) {
                const setjson = JSON.stringify(data);
                // 日付が違う場合は上書きする
                localStorage.setItem('usage', setjson);
            }
        }
    },

    async setStatuses(organizationId, idToken) {
        const today = utils.formatDate(new Date(), 'YYYY-MM-DD');
        const storedSession = JSON.parse(localStorage.getItem('dates'));
        if (!storedSession || storedSession.date != today) {
            const res = await this.getOrgsApi(idToken, organizationId);
            const data = this.formatOrgData(res);
            if (data) {
                const setjson = JSON.stringify(data);
                localStorage.setItem('dates', setjson);
            }
        }
    },

    getUsagesApi(idToken, keys) {
        const itemsParam = keys.join(',');
        const params = {
            items: itemsParam,
            projects: 'all'
        };
        return apiUsages
            .get(params, idToken)
            .then(response => {
                return response;
            })
            .catch(error => {});
    },

    getOrgsApi(idToken, organizationId) {
        return apiOrgs.statuses
            .get(idToken, organizationId)
            .then(response => {
                return response;
            })
            .catch(error => {});
    },

    formatOrgData(response) {
        try {
            const today = utils.formatDate(new Date(), 'YYYY-MM-DD');
            const dates = {
                startDate: response.data.startDate,
                date: today
            };
            return dates;
        } catch {
            return null;
        }
    },

    // APIのレスポンスからローカルストレージに格納する値を整形
    formatUsageData(response) {
        try {
            const today = utils.formatDate(new Date(), 'YYYY-MM-DD');
            const data = {
                date: today
            };
            response.data.items.forEach(item => {
                switch (item.name) {
                    case 'projects':
                        data.projects = item.current;
                        break;
                    case 'nominated_keywords':
                        data.nominatedKeywords = item.current;
                        break;
                    case 'research-keywords':
                        data.researchKeywords = item.current;
                        break;
                    case 'tasks':
                        data.tasks = item.current;
                        break;
                    case 'competitor-analyses':
                        data.competitorAnalyses = item.current;
                        break;
                    case 'content-plan-keywords':
                        data.contentPlanKeywords = item.current;
                        break;
                    case 'page-checkups':
                        data.pageCheckups = item.current;
                        break;
                    case 'observation-keywords':
                        data.observationKeywords = item.current;
                        break;
                    case 'competitor-site-analysis':
                        data.competitorSiteAnalysis = item.current;
                        break;
                }
            });
            return data;
        } catch {
            return null;
        }
    },

    async getTrackingData(userId, projectId, idToken) {
        // store内からorganizationIdを取得する
        const organization = store.getters['view/organization'];
        const organizationId =
            organization && organization.organizationId
                ? organization.organizationId
                : null;
        const organizationName =
            organization && organization.organizationName
                ? organization.organizationName
                : null;
        const saasId =
            organization && organization.saasId ? organization.saasId : null;
        const startDate =
            organizationId && localStorage.getItem('dates')
                ? JSON.parse(localStorage.getItem('dates')).startDate
                : null;
        const today = utils.formatDate(Date.now(), 'YYYY-MM-DD');
        const useDays = startDate
            ? utils.getDays(Date.parse(startDate), Date.parse(today))
            : 0;
        const storedUsage = !store.getters['user/hasOrganizations']
            ? localStorage.getItem('usage')
            : null;
        const isEmployee = store.state.user.me.isEmployee;

        const planId = store.state.user.plan.planId;

        let trackingData = {
            userId: userId,
            lastDate: today,
            isEmployee: isEmployee,
            projectId: projectId,
            organizationId: organizationId,
            organizationName: organizationName,
            saasId: saasId,
            planId: planId
        };

        // startDateがnullの場合はdataLayerに送らない
        if (startDate) {
            trackingData.startDate = startDate;
            trackingData.useDays = useDays;
        }
        // Usageを設定。ローカルストレージに値があれば追加する。
        if (storedUsage) {
            let jsonUsage = JSON.parse(storedUsage);
            // dateが今日のものである場合のみ追加する
            if (jsonUsage.date == today) {
                delete jsonUsage.date;
                trackingData = { ...trackingData, ...jsonUsage };
            }
        }
        return trackingData;
    }
};

export default tracking;
